import { useEffect, useState } from 'react';

/** Re-render about once a minute so relative timestamps stay fresh. */
export default function useMinuteTick(intervalMs = 60000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
